import "./DashboardOrderSkeleton.css";

export default function DashboardOrdersSkeleton() {
  return (
    <div className="wrapper dashboard-orders-skeleton">

      {/* Title */}
      <div className="dos-title skeleton-box" />

      {/* Tabs */}
      <div className="dos-tabs">
        <div className="dos-tab skeleton-box" />
        <div className="dos-tab skeleton-box" />
        <div className="dos-tab skeleton-box" />
        <div className="dos-tab skeleton-box" />
        <div className="dos-tab skeleton-box" />
      </div>

      {/* Orders */}
      <div className="dos-orders">

        <SkeletonOrderCard />

        <SkeletonOrderCard />

        <SkeletonOrderCard />

      </div>

    </div>
  );
}


/* -----------------------------------
   Skeleton Order Card
----------------------------------- */

function SkeletonOrderCard() {
  return (
    <div className="dos-order-card">

      {/* Header */}
      <div className="dos-card-header">

        <div className="dos-status">
          <div className="dos-icon skeleton-box" />
          <div className="dos-status-text skeleton-box" />
        </div>

        <div className="dos-detail skeleton-box" />

      </div>


      {/* Card */}
      <div className="dos-card-content">

        {/* Order number / price */}
        <div className="dos-specific-header">

          <div className="dos-line-group">
            <div className="dos-small-line skeleton-box" />
            <div className="dos-medium-line skeleton-box" />
          </div>

          <div className="dos-price skeleton-box" />

        </div>


        {/* Information */}
        <div className="dos-information">

          <div className="dos-info-item">
            <div className="dos-label skeleton-box" />
            <div className="dos-value skeleton-box" />
          </div>

          <div className="dos-info-item">
            <div className="dos-label skeleton-box" />
            <div className="dos-value skeleton-box" />
          </div>

          <div className="dos-info-item">
            <div className="dos-label skeleton-box" />
            <div className="dos-value skeleton-box" />
          </div>

        </div>

      </div>

    </div>
  );
}